module.exports = __webpack_public_path__ + "img/Woman_Presentation.6da9eb9.png";